import { formatarMesPorExtenso } from '@/lib/formato';

/**
 * As competências que a lista oferece: do mês que vem até 24 meses atrás, a
 * mais recente primeiro, cada uma como aaaa-mm-01 (o que o servidor guarda) e
 * escrita "Setembro de 2026" (o que a pessoa lê). Um valor fora da janela,
 * vindo de um registro antigo, entra também — senão a lista o apagaria.
 *
 * Mora fora de `CampoDeData.tsx` porque o arquivo do componente só exporta
 * componente (o recarregamento rápido do Vite pede isso).
 */
export function opcoesDeCompetencia(
  hoje: Date,
  atual = '',
  janela: { readonly aFrente?: number; readonly atras?: number; readonly crescente?: boolean } = {},
): readonly { readonly valor: string; readonly rotulo: string }[] {
  /* A JANELA muda com o assunto: a competência de um lançamento olha para
     trás (1 à frente, 24 atrás); o mês PRETENDIDO de uma proposta de
     investimento olha para a frente (achado dos robôs, 20/10/2026). */
  const aFrente = janela.aFrente ?? 1;
  const atras = janela.atras ?? 24;
  const valores: string[] = [];
  for (let i = aFrente; i >= -atras; i -= 1) {
    const mes = new Date(hoje.getFullYear(), hoje.getMonth() + i, 1);
    valores.push(`${String(mes.getFullYear())}-${String(mes.getMonth() + 1).padStart(2, '0')}-01`);
  }
  if (/^\d{4}-(0[1-9]|1[0-2])-01$/.test(atual) && !valores.includes(atual)) valores.push(atual);
  /* Crescente quando a lista olha para a frente: o mês que vem fica no topo. */
  const ordenados = janela.crescente ? [...valores].sort() : valores;
  return ordenados.map((valor) => ({ valor, rotulo: formatarMesPorExtenso(valor) }));
}
